import { useState, useEffect } from "react";
import StatsCard from "../cards/StatsCard";
import State from "../State";
import Modal from "./Modal";

const FailedTestModal = ({
  id,
  isOpened,
  correctAnswersCount,
  wrongAnswersCount,
  quizPercentage,
  onClose,
}) => {
  const [showModal, setShowModal] = useState(isOpened);

  useEffect(() => {
    const el = document.getElementById(id);
    if (!el) return;
    const bootstrapModal = window.bootstrap?.Modal?.getOrCreateInstance(el);
    if (!bootstrapModal) return;
    if (isOpened) {
      bootstrapModal.show();
    } else {
      bootstrapModal.hide();
    }
  }, [isOpened, id]);

  useEffect(() => {
    setShowModal(isOpened);
  }, [isOpened]);

  const total = (correctAnswersCount ?? 0) + (wrongAnswersCount ?? 0);
  const computedPercentage =
    total > 0 ? parseInt(((correctAnswersCount ?? 0) / total) * 100) : 0;
  const percentage =
    quizPercentage != null && !Number.isNaN(Number(quizPercentage))
      ? Number(quizPercentage)
      : computedPercentage;

  const handleClose = () => {
    onClose?.();
    window.location.reload(false);
  };

  return (
    <Modal id={id} maxWidth="600" isOpened={showModal} hasCloseBtn={false}>
      <State
        titleFontSize={24}
        descFontSize={14}
        className="failed-test"
        id="fail-test"
        hasIconStroke
        type="fail"
        title="لم تجتز الاختبار"
        desc="لم تحقق النسبة المطلوبة. ننصحك بمراجعة الدروس."
      >
        <div className="row state__details">
          <div className="col-sm-4 mb-3 mb-sm-0">
            <StatsCard
              title="درجتك"
              num={`${percentage}%`}
              state="default"
              titleFontColor="font-color-grey"
            />
          </div>
          <div className="col-sm-4 mb-3 mb-sm-0">
            <StatsCard
              title="الإجابات الصحيحة"
              num={correctAnswersCount ?? 0}
              state="success"
            />
          </div>
          <div className="col-sm-4 mb-3 mb-sm-0">
            <StatsCard
              title="الإجابات الخاطئة"
              num={wrongAnswersCount ?? 0}
              state="fail"
            />
          </div>
        </div>
        <div className="d-grid gap-2 state__actions">
          <button
            type="button"
            className="btn btn-main-color"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          >
            إغلاق
          </button>
        </div>
      </State>
    </Modal>
  );
};

export default FailedTestModal;
